module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid24_980x861.c967045.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid24_980x861.jpg
// module id = qafR
// module chunks = 0